// removed by extract-text-webpack-plugin
module.exports = {"root":"src-byos-component----SyntaxHighlightStyle-module---root---3Croz"};


//////////////////
// WEBPACK FOOTER
// ./src/byos/component/SyntaxHighlightStyle.module.css
// module id = 622
// module chunks = 198924488578035